import { apiSlice } from "@/shared/api/api-slice"

import {
  type GetPersonalSubscriptionResponse,
  type ListSubscriptionsRequest,
  type ListSubscriptionsResponse
} from "../model/types"

export const getSubscriptionApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    listSubscriptions: builder.query<ListSubscriptionsResponse, ListSubscriptionsRequest>({
      query: ({ chatId }) => ({
        url: "/api/v1/subscription/list",
        params: chatId ? { chat_id: chatId } : undefined
      }),
      providesTags: ["Subscription"]
    }),
    getPersonalSubscription: builder.query<GetPersonalSubscriptionResponse, undefined>({
      query: () => "/api/v1/subscription/personal",
      providesTags: ["PersonalSubscription"]
    })
  })
})

export const { useListSubscriptionsQuery, useGetPersonalSubscriptionQuery } = getSubscriptionApi
